// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Klhb","content":"styles_content__6z0RG","row":"styles_row__1yQQH","footer":"styles_footer__3wHTs","phraseLength":"styles_phraseLength__1_NsX"};